import { JobiLoader } from '@/ui/rapid-ui/jobiloader'
import { whatsAppAiActivityState } from '@jobilla/nexus-sdk'
import type { WhatsAppAiActivityState } from '@jobilla/nexus-sdk'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

// No real turn takes this long; past it the state is stale (e.g. a worker died mid-turn).
const STALE_AFTER_MS = 2 * 60 * 1000

export function WhatsAppAiThinkingBubble({
	activityState,
	activitySince,
}: {
	activityState?: WhatsAppAiActivityState | null
	activitySince?: string | null
}): React.ReactNode {
	const { t } = useTranslation('common')
	const busy = activityState === whatsAppAiActivityState.queued || activityState === whatsAppAiActivityState.thinking
	const deadline = activitySince ? Date.parse(activitySince) + STALE_AFTER_MS : null
	const [now, setNow] = useState(() => Date.now())

	useEffect(() => {
		if (!busy || deadline === null) {
			return
		}
		setNow(Date.now())
		const timer = window.setTimeout(() => setNow(Date.now()), Math.max(0, deadline - Date.now()))
		return () => window.clearTimeout(timer)
	}, [busy, deadline])

	if (!busy || (deadline !== null && now >= deadline)) {
		return null
	}

	return (
		<div className="flex items-center gap-2 px-3 py-2 text-sm text-grey-500">
			<JobiLoader scale={0.4} />
			<span>{t('whatsapp.aiThinking.label')}</span>
		</div>
	)
}
